import React, { useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import AWS from "aws-sdk";
import { enrollPatientByFace, signupByFace } from "../../../api/apiHandler";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { loginStoreData } from "../../patient/common/RedirectPathMange";
const videoConstraints = {
  width: 300,
  height: 200,
  facingMode: "user",
};

const FaceSignup = () => {
  const webcamRef = useRef(null);
  let navigate = useNavigate();
  const [name, setName] = useState({ firstname: "", lastName: "", role: "" });
  const [image, setImage] = useState(null);
  const [showWebcam, setShowWebcam] = useState(false);
  console.log(name, "bakakdbjdbk22");

  // Capture image and start detection
  const handleCapture = () => {
    const screenshot = webcamRef.current?.getScreenshot();
    if (!screenshot) {
      alert("Unable to capture image. Try again.");
      return;
    }
    // setImage(screenshot);
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    checkIfFaceExists(screenshot);
  };

  const checkIfFaceExists = async (base64Image) => {
    const buffer = base64ToBuffer(base64Image);
    const existingFace = await searchFaceByImage(buffer);

    if (existingFace?.FaceId) {
      console.log("✅ Face already enrolled:", existingFace.FaceId);
      Swal.close();
      Swal.fire({
        icon: "info",
        title: "This user is already exists",
        toast: true,
        showConfirmButton: false,
        timer: 4000,
      });
    } else {
      await handleSaveManually(buffer);
    }
  };

  // Convert base64 → Uint8 buffer
  function base64ToBuffer(base64String) {
    const base64Data = base64String?.split(";base64,")?.[1];
    return Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  }

  // AWS Rekognition setup
  const rekognition = new AWS.Rekognition({
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
    region: process.env.REACT_APP_AWS_S3_REGION,
  });

  // Search face in collection
  const searchFaceByImage = async (imageBuffer) => {
    const params = {
      CollectionId: "Face-collection",
      FaceMatchThreshold: 90,
      Image: { Bytes: imageBuffer },
      MaxFaces: 1,
    };

    try {
      const result = await rekognition.searchFacesByImage(params).promise();
      console.log(result, "searchFaceByImage");

      if (result.FaceMatches && result.FaceMatches.length > 0) {
        return result.FaceMatches[0].Face;
      }
      return null;
    } catch (err) {
      console.error("Face search failed:", err);
      return null;
    }
  };

  // Index new face if not found
  const indexFaceFromS3Url = async (userId, imageBuffer) => {
    const params = {
      CollectionId: "Face-collection",
      DetectionAttributes: ["ALL"],
      ExternalImageId: userId,
      Image: { Bytes: imageBuffer },
    };

    return await rekognition.indexFaces(params).promise();
  };

  // Enroll new patient using Rekognition FaceId
  const handleSaveManually = async (buffer) => {
    try {
      const user_id = localStorage.getItem("user_id");

      const result = await indexFaceFromS3Url(user_id, buffer);
      const data = result?.FaceRecords?.[0]?.Face;

      if (!data?.FaceId) {
        throw new Error("Face indexing failed. No FaceId returned.");
      }

      const faceData = {
        first_name: name.firstname,
        last_name: name.lastName,
        awsFaceId: data.FaceId,
        role: name.role,
      };
      console.log(faceData, "payloadDatatata", name);

      let response = await signupByFace(faceData);

      if (typeof response === "string") {
        response = JSON.parse(response);
        loginStoreData(response?.data);
        Swal.close();
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error ",
        text: err.message || "Something went wrong.",
      });
    }
  };

  return (
    <div className="container ">
      <div className="row align-items-center justify-content-center">
        <div className="col-lg-6 col-xl-6 col-xxl-5 col-12">
          <div className="login-sec">
            <div className="logo-size">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/logo--a.png"}
                alt="logo"
              />
            </div>
            <div className=" mb-4">
              <p className="font_26 font_600 text-center ">Biometric Signup</p>
            </div>
            <div className="text-center mt-3">
              <Link
                to="/log-in"
                className="text-white px-4 d-inline-flex align-items-center justify-center btn rounded"
                style={{ background: "#fc7c37", fontSize: 13 }}
              >
                Already a member? Login here
              </Link>
            </div>
            {/* {!showWebcam ? (
              <button
                className="btn btn-primary "
                onClick={() => setShowWebcam(true)}
              >
                Enable Face Authentication
              </button>
            ) : (
             
            )} */}
            <>
              <div className="mb-3 input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter first name"
                  value={name.firstname}
                  onChange={(e) =>
                    setName((prev) => ({
                      ...prev,
                      firstname: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="mb-3 input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter last name"
                  value={name.lastName}
                  onChange={(e) =>
                    setName((prev) => ({ ...prev, lastName: e.target.value }))
                  }
                />
              </div>
              <div className="mb-4">
                <p className="mb-2 font_18 font_500">Select role</p>
                <div className="d-flex gap-3 align-items-center">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input radio"
                      type="radio"
                      name="role"
                      id="patient"
                      value="1"
                      checked={name.role === "1"}
                      onChange={(e) =>
                        setName((prev) => ({ ...prev, role: e.target.value }))
                      }
                    />
                    <label className="form-check-label" htmlFor="patient">
                      Patient
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input radio"
                      type="radio"
                      name="role"
                      id="doctor"
                      value="2"
                      checked={name.role === "2"}
                      onChange={(e) =>
                        setName((prev) => ({ ...prev, role: e.target.value }))
                      }
                    />
                    <label className="form-check-label" htmlFor="doctor">
                      Doctor
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input radio"
                      type="radio"
                      name="role"
                      id="chemist"
                      value="3"
                      checked={name.role === "3"}
                      onChange={(e) =>
                        setName((prev) => ({ ...prev, role: e.target.value }))
                      }
                    />
                    <label className="form-check-label" htmlFor="chemist">
                      Chemist
                    </label>
                  </div>
                </div>
              </div>
              {(!name.firstname.trim() ||
                !name.lastName.trim() ||
                !name.role.trim()) && (
                <p className="text-danger  mt-2 font_12">
                  Please enter both first and last name and role to enable
                  capture.
                </p>
              )}
              {image ? (
                <div className=" mt-4">
                  <img
                    src={image}
                    alt="Captured"
                    className="img-thumbnail shadow"
                    style={{ width: "430px", borderRadius: "8px" }}
                  />
                </div>
              ) : (
                <div className="text-center mb-3">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    height={200}
                    width={300}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    className=" rounded w-100"
                  />
                </div>
              )}

              <button
                className="submit-btn font_18 w-100"
                onClick={handleCapture}
                disabled={
                  !name.firstname.trim() ||
                  !name.lastName.trim() ||
                  !name.role.trim()
                }
              >
                📸 Capture & Signup
              </button>
            </>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default FaceSignup;
